import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { getStoredUser } from './user-storage.util';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const user = getStoredUser();

    if (!user || !user.id) {
      return this.router.createUrlTree(['/login']);
    }

    // A missing or empty role defaults to PROFESSIONAL_ASSOCIATE.
    const userRole: string = user.role || 'PROFESSIONAL_ASSOCIATE';
    const requiredRole: string =
      route.data?.['requiredRole'] || 'PROFESSIONAL_ASSOCIATE';

    if (userRole === requiredRole) {
      return true;
    }

    // Role mismatch — redirect to the user's own landing page.
    if (userRole === 'INTERNAL') {
      return this.router.createUrlTree(['/internal']);
    }

    return this.router.createUrlTree(['/invitations']);
  }
}
